import React from 'react';
import "../../assets/css/scss/component/_latestNews.scss";
import { IPostData } from '../../interfaces/post';
import ImageTitleDescHoriz from '../image/imageTitleDescHoriz';

type ILatestNewsProp = {
    news: Array<IPostData>
}
export default function LatestNews(props: ILatestNewsProp) {
    return (
        <div className="news">
            <div className="title theme-gray">
                <h3 className="mb-0 theme-green">Latest News</h3>
            </div>
            <div className="news-detail theme-dark-gray">
                {props?.news ? props?.news.map((data: IPostData) => (
                    <ImageTitleDescHoriz data={data} isBigCard={true} />
                ))
                    : null}
                {/* <div className="d-flex align-items-center  flex-sm-nowrap flex-wrap pb-4 pb-xl-3">
                    <Link to="/">
                        <Image src="/assets/images/baseball1.jpg" alt="baseball" fluid />
                    </Link>
                    <div className="news-title">
                        <Link to="/" className="theme-green bold h4">
                            Report: <span className="theme-white d-inline">MLB codring starting extra innings with runner</span>
                        </Link>
                        <p className="font-14 theme-white">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut our labore et dolore magna aliquac uis ipsum.</p>
                        <h3 className="theme-green h6">By :The League Staff</h3>
                    </div>
                </div> */}
            </div>
        </div>
    )
}
